import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { clsx as k } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { RocheUIIcon as m } from "../icon/roche-icon.js";
import { NUMBER_OF_DECIMALS as h, prettyPrintAbsoluteChange as N, prettyPrintRelativeChange as v } from "./pretty-print.js";
import c from "./roche-stock-price.module.scss.js";
const A = ({
  heading: r,
  href: l,
  price: a,
  currency: t,
  change: o,
  relativeChange: n,
  timeIntervalLabel: p,
  unavailableLabel: d
}) => {
  if (!(a !== void 0 && t !== void 0 && o !== void 0 && n !== void 0))
    return /* @__PURE__ */ s("div", { className: c["stock-price"], children: [
      /* @__PURE__ */ e("h3", { className: c["stock-price__heading"], children: r }),
      /* @__PURE__ */ e("span", { className: c["stock-price__unavailable"], children: d })
    ] });
  const i = ["stock-down", "stock-equal", "stock-up"][Math.sign(o) + 1], _ = k(c["stock-price__icon"], {
    [c["stock-price__icon--down"]]: i === "stock-down",
    [c["stock-price__icon--equal"]]: i === "stock-equal",
    [c["stock-price__icon--up"]]: i === "stock-up"
  });
  return /* @__PURE__ */ s("a", { className: c["stock-price"], href: l, children: [
    /* @__PURE__ */ e("h3", { className: c["stock-price__heading"], children: r }),
    /* @__PURE__ */ s("div", { className: c["stock-price__price"], children: [
      /* @__PURE__ */ e("span", { className: c["stock-price__value"], children: a.toFixed(h) }),
      /* @__PURE__ */ e("span", { className: c["stock-price__currency"], children: t })
    ] }),
    /* @__PURE__ */ s("div", { className: c["stock-price__daily-change"], children: [
      /* @__PURE__ */ e("span", { className: _, "aria-hidden": "true", children: /* @__PURE__ */ e(m, { icon: i, height: "32px" }) }),
      /* @__PURE__ */ s("span", { className: c["stock-price__difference"], children: [
        /* @__PURE__ */ e("span", { className: c["stock-price__price-difference"], children: N(o) }),
        /* @__PURE__ */ e("span", { className: c["stock-price__relative-difference"], children: v(n) })
      ] }),
      /* @__PURE__ */ e("span", { className: c["stock-price__time-interval"], children: p })
    ] })
  ] });
};
export {
  A as RocheUIStockPrice
};
